import React from 'react';

const Plan = ({ link }) => {
  return (
    <section id="plans">
      {link ? (
        <iframe src={link} title="Plans PDF" width="100%" height="500px" />
      ) : (
        <p>No plans selected</p>
      )}
    </section>
  );
};

export default Plan;
